export default __webpack_public_path__ + "static/media/email.6538f2cc.svg";